import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import NetworkError from '../components/NetworkError/NetworkError';

const loadableProps = {
  timeout: 60 * 1000,
};

// 首页
const AsyncHomePage = Loadable({
  ...loadableProps,
  loader: () => import('../index/Index' /* webpackChunkName:'index' */),
  loading: NetworkError,
});

// 支付状态页
const PaymentStatus = Loadable({
  ...loadableProps,
  loader: () => import('../page/paymentStatus/index' /* webpackChunkName:'paymentStatus' */),
  loading: NetworkError,
});

export default () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={AsyncHomePage} />
        <Route path="/index" component={AsyncHomePage} />
        <Route path="/paymentStatus" component={PaymentStatus} />
        <Route component={AsyncHomePage} />
      </Switch>
    </Router>
  );
};
